import { render, staticRenderFns } from "./WizardTwo.vue?vue&type=template&id=64f37662"
import script from "./WizardTwo.vue?vue&type=script&lang=ts"
export * from "./WizardTwo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports